import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

function OtpVerify(props) {
  const { email } = props;
  const [otp, setOtp] = useState(["", "", "", ""]);
  let navigate = useNavigate();
  const inputsRef = useRef([]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async () => {
    const finalOtp = otp.join("");

    if (finalOtp.length !== 4) return;

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/otp/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, otp: finalOtp }),
    });
    const result = await response.json();
    
    if (result.success) {
      localStorage.setItem("token", result.token);
      navigate("/");
      window.location.reload();
    }
  };

  return (
    <div className=" mt-2 text-center">
      <div className="d-flex justify-content-center gap-2">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            maxLength="1"
            className="form-control text-center"
            style={{ width: "50px", height: "50px", fontSize: "20px" }}
            value={digit}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputsRef.current[index] = el)}
          />
        ))}
      </div>

      <button
        className="btn btn-primary mt-3"
        onClick={handleSubmit}
        disabled={otp.includes("")}
      >
        Verify OTP
      </button>
    </div>
  );
}

export default OtpVerify;
